export const countdown = () => {
  const countdownTime = new Date(`June 14 2024 11:00:00 GMT+0900`);
  const daysEl = document.querySelector(".js-clock-days");
  const hoursEl = document.querySelector(".js-clock-hours");
  const minutesEl = document.querySelector(".js-clock-minutes");
  const secondsEl = document.querySelector(".js-clock-seconds");

  if (new Date() > countdownTime) {
    document.querySelector(".js-teaser").style.display = "none";
  } else {
    document.querySelector(".js-page-content").style.display = "none";
  }

  const timer = setInterval(() => {
    const currentTime = new Date();
    const diff = countdownTime - currentTime;

    const d = Math.floor(diff / 1000 / 60 / 60 / 24);
    const h = Math.floor(diff / 1000 / 60 / 60) % 24;
    const m = Math.floor(diff / 1000 / 60) % 60;
    const s = Math.floor(diff / 1000) % 60;

    daysEl.innerText = d < 10 ? "0" + d : d;
    hoursEl.innerText = h < 10 ? "0" + h : h;
    minutesEl.innerText = m < 10 ? "0" + m : m;
    secondsEl.innerText = s < 10 ? "0" + s : s;

    if (diff < 0) {
      clearInterval(timer);
      document.querySelector(".js-teaser").style.display = "none";
      document.querySelector(".js-page-content").style.display = "block";
    }
  }, 1000);
};
